import { React, Fragment, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import { useAlert } from "react-alert";
import propTypes from "prop-types";
// import { browserName, browserVersion, osVersion, osName } from "react-device-detect";
import {
  FORM_VALIDATION_SCRIPTS_QUEUE,
  FORM_VALIDATION_SCRIPTS_DEQUEUE,
} from "../../../constants";
import errorHandler from "../../../hoc/ErrorHandler";
import BrandInfo from "./BrandInfo/BrandInfo";
import HiddenBrandInfo from "./BrandInfo/Hidden/Hidden";
import Form from "./Form/Form";
import SystemCopyright from "../../../components/UI/SystemCopyright/SystemCopyright";

/* Temporarily disabled QR setup parsing.
const findOtpauthUri = (value) => {
  if (!value) return null;
  if (typeof value === "string") {
    return value.startsWith("otpauth://") ? value : null;
  }
  if (Array.isArray(value)) {
    return value.map(findOtpauthUri).find(Boolean) || null;
  }
  if (typeof value === "object") {
    const directUri =
      value.otpauth_uri || value.otpauthUri || value.otpAuthUri;
    if (typeof directUri === "string") return directUri;

    return Object.values(value).map(findOtpauthUri).find(Boolean) || null;
  }
  return null;
};
*/

const Login = (props) => {
  document.body.className = "page-login-v2 layout-full page-dark";

  const [authenticated, setAuthenticated] = useState(false);
  // const [otpRequired, setOtpRequired] = useState(false);
  // const [otpauthUri, setOtpauthUri] = useState(null);

  useEffect(() => {
    FORM_VALIDATION_SCRIPTS_QUEUE();
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("code");

    // localStorage.removeItem("username");
    // localStorage.removeItem("code");

    if (typeof Storage !== "undefined")
      localStorage.setItem(
        "remark.material.iconbar.skinTools",
        '{"sidebar":"dark","navbar":"brown","navbarInverse":"true","primary":"primary"}'
      );
    return () => FORM_VALIDATION_SCRIPTS_DEQUEUE();
  }, []);

  const alert = useAlert();

  const loginHandler = async (credentials) => {
    if (props.userIsBlocked) return;

    sessionStorage.setItem("username", credentials.username);
    sessionStorage.setItem("code", credentials.code);

    const response = await axios.post("/auth/login", credentials);
    /* Temporarily disabled enhanced login error handling.
    let response;
    try {
      response = await axios.post("/auth/login", credentials);
    } catch (error) {
      alert.show(
        error.response?.data?.message || "Authentication failed. Please try again.",
        { type: "error" }
      );
      return;
    }
    */

    /* Temporarily disabled OTP challenge handling.
    if (response.status === 202) {
      // setOtpauthUri(findOtpauthUri(response.data));
      setOtpRequired(true);
      alert.show(response.data.message || "Enter the six-digit OTP to continue.", {
        type: "info",
      });
      return;
    }
    */

    if (response.status === 200) {
      const data = response.data.data;
      alert.show(response.data.message, { type: "success" });

      // Set the access token, refresh token and user data in localStorage for persistence across sessions.
      localStorage.setItem('access_token', data.access_token);
      localStorage.setItem('refresh_token', data.refresh_token);
      localStorage.setItem('user_data', JSON.stringify({
        is_admin: data.is_admin,
        company_code: data.company_code,
        default_company: data.default_company,
        company_name: data.company_name,
        user_id: data.user_id,
        user_name: data.user_name,
        user_email: data.user_email,
        is_ict: data.is_ict,
        token_expiry: data.token_expiry,
        token_expiry_Tminus: data.token_expiry_Tminus,
        login_audit_id: data.login_audit_id,
        username: credentials.username
      }));

      // Also keep in Redux for the current session.
      props.onUserAuthenticated(
        true,
        data.is_admin,
        data.company_code,
        data.default_company,
        data.company_name,
        data.user_id,
        data.user_name,
        data.user_email,
        data.access_token,
        data.is_ict,
        data.token_expiry,
        data.token_expiry_Tminus,
        data.refresh_token,
        data.login_audit_id,
        credentials.username
      );

      return setAuthenticated(true);
    }
  };

  return (
    <Fragment>
      {authenticated && <Redirect to="/dashboard" />}
      <div
        dangerouslySetInnerHTML={{
          __html: `
                <!--[if lt IE 8]>
                    <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.</p>
                <![endif]-->`,
        }}
      />
      <div className="page">
        <div className="page-content">
          <BrandInfo />
          <div className="page-login-main">
            <HiddenBrandInfo />
            <h3 className="font-size-24">Sign In</h3>
            <p>Provide your eBoard authentication credentials</p>
            <Fragment>
              <Form
                loginHandler={loginHandler}
                otpRequired={/* OTP temporarily disabled */ false}
                otpauthUri={/* QR setup temporarily disabled */ undefined}
              />
              <SystemCopyright />
            </Fragment>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userIsBlocked: state.auth.userIsBlocked,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUserAuthenticated: (
      authenticated,
      isAdmin,
      companyCode,
      companyId,
      companyName,
      userId,
      userName,
      userEmail,
      accessToken,
      isICT,
      tokenExpiry,
      tokenExpiryTminus,
      refreshToken,
      loginLogId,
      loginName
    ) =>
      dispatch({
        type: "SIGN_IN",
        payload: {
          authenticated: authenticated,
          isAdmin: isAdmin,
          companyCode: companyCode,
          companyId: companyId,
          companyName: companyName,
          userId: userId,
          userName: userName,
          userEmail: userEmail,
          accessToken: accessToken,
          isICT: isICT,
          tokenExpiry: tokenExpiry,
          tokenExpiryTminus: tokenExpiryTminus,
          refreshToken: refreshToken,
          loginLogId: loginLogId,
          loginName: loginName,
        },
      }),
  };
};

Login.propTypes = {
  onUserAuthenticated: propTypes.func,
  loginAttempts: propTypes.number,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(errorHandler(Login, axios));
